import React from 'react'
import styles from '../../styles/products.module.css';

interface ProductAmrRobotCardItemProps {
    image: string;
    imageWebp: string;
    title: string;
    content: string;
}

const ProductAmrRobotCardItem: React.FC<ProductAmrRobotCardItemProps> = ({ image, imageWebp, title, content }) => {
    return (
        <div className={styles.card}>
            <div className={styles.cardImage}>
                <img src={image} srcSet={imageWebp} alt={title} loading="lazy" />
            </div>
            <div className={styles.cardContent}>
                <h3>{title}</h3>
                <p>{content}</p>
            </div>
        </div>
    )
}

export default ProductAmrRobotCardItem;